



























































































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn, DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import {
  FETCH_PRODUCT_FELD_LIST, FETCH_PRODUCT_GROUP,
  SEARCH_PRODUCT_LIST
} from '@/store/action-types'
import {
  ProductGroupResponse, ProductSearchRecordResponse,
  ProductZusatzfelderType,
  ProductZusatzfelderTypesResponse
} from '@/types/service-response'
import { ProductSearchPayload, ProductZusatzfelderSearchItem } from '@/types/payload'
import { ProductGroup } from '@/model/products/ProductGroup'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import { ProductSearchRecord } from '@/model/products/ProductSearchRecord'

interface ComponentData {
  loading: boolean

  productGroupList: ProductGroup[]

  schluessel: string
  bezeichnung: string
  beschreibung: string
  gruppe: number[]
  barcode: string
  externeProduktNummer: string
  verfuegbar: boolean
  nurBevorzugteLager: boolean
  nurAuslierfortSyzSRO: boolean
  gesperrteAusblenden: boolean
  verfuegbarReservationen: boolean
  verfuegbarBestellungen: boolean

  productList: ProductSearchRecord[]
  productStatus: string
  feldList: ProductZusatzfelderType[]
  operatorList: any[]
  boolOperatorNextList: any[]
  additionalFilterList: any[]
}

export default Vue.extend({
  name: 'ProductSearchDialog',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
  },

  data (): ComponentData {
    return {
      loading: false,

      productGroupList: [],

      schluessel: '',
      bezeichnung: '',
      beschreibung: '',
      gruppe: [],
      barcode: '',
      externeProduktNummer: '',
      verfuegbar: false,
      nurBevorzugteLager: false,
      nurAuslierfortSyzSRO: false,
      gesperrteAusblenden: false,
      verfuegbarReservationen: false,
      verfuegbarBestellungen: false,

      productList: [],
      productStatus: '1',
      feldList: [],
      operatorList: [
        {id: 1, name: '='},
        {id: 2, name: 'Like'},
        {id: 3, name: 'grosser'},
        {id: 4, name: 'grosser gleich'},
        {id: 5, name: 'kleiner'},
        {id: 6, name: 'kleiner gleich'},
        {id: 7, name: 'nicht gleich'},
        {id: 8, name: 'nicht wie'}
      ],
      boolOperatorNextList: [
        {id: 0, name: ''},
        {id: 1, name: 'UND'},
        {id: 2, name: 'ODER'}
      ],
      additionalFilterList: [
        {id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}
      ]
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    rowDblClick (event: any): void {
      this.$emit('selectedProduct', event.data)
    },

    onChangeFeld (index: number, item: any): void {
      if(item === 0) {
        this.additionalFilterList[index].feld = null
        this.additionalFilterList[index].operator = null
        this.additionalFilterList[index].inhalt = ''
        this.additionalFilterList[index].boolOperatorNext = 0
        this.additionalFilterList.splice(index + 1, this.additionalFilterList.length)
      }
    },

    onChangeAdditional (index: number, item: any): void {
      if(item === 0) {
        if(this.additionalFilterList && this.additionalFilterList[index + 1]) {
          this.additionalFilterList.splice(index + 1, 1)
        }
      } else {
        if(this.additionalFilterList && !this.additionalFilterList[index + 1]) {
          const highId = _.maxBy(this.additionalFilterList, 'id')
          this.additionalFilterList.push({id: highId.id + 1, feld: null, operator: null, inhalt: '', boolOperatorNext: 0})
        }
      }
    },

    onSearchButtonClick (): void {
      this.productList = []
      this.searchProduct()
    },

    async searchProduct (): Promise<void> {
      let additionalFilterSearchList: ProductZusatzfelderSearchItem[] = []
      this.additionalFilterList.forEach((item: any) => {
        if(item.feld && item.operator && item.inhalt) {
          additionalFilterSearchList.push({
            Feldtyp: item.feld,
            Operator: item.operator,
            BoolOperatorNext: item.boolOperatorNext,
            Inhalt: item.inhalt
          })
        }
      })

      const payload: ProductSearchPayload = {
        Bezeichnung: this.bezeichnung,
        Gruppe: null,
        ProduktGruppen: this.gruppe,
        ProductZusatzfelderSearchItems: additionalFilterSearchList,

        Mitarbeiter: this.currentUserId,
        Sprache: this.selectedLanguageId,
        //MaxRecords: number
        Alle: this.productStatus === '0',
        Aktiv: this.productStatus === '1',
        Passiv: this.productStatus === '2',
        Schluessel: this.schluessel,
        Beschreibung: this.beschreibung,
        Barcode: this.barcode,
        Nummer: this.externeProduktNummer
      }

      try {
        this.loading = true
        const response: ProductSearchRecordResponse = await this.$store.dispatch(SEARCH_PRODUCT_LIST, payload)
        if(!response.IsError && response.Results) {
          this.productList = ProductSearchRecord.createFromResponse(response.Results)
        }
      } catch {

      } finally {
        this.loading = false
      }
    },

    async fetchProductGroupList (): Promise<void> {
      try {
        const response: ProductGroupResponse = await this.$store.dispatch(FETCH_PRODUCT_GROUP)
        if(!response.IsError && response.Data) {
          this.productGroupList = ProductGroup.createFromResponse(response.Data)
        } else {}
      } catch {}
    },

    async fetchFeldList (): Promise<void> {
      try {
        const response: ProductZusatzfelderTypesResponse = await this.$store.dispatch(FETCH_PRODUCT_FELD_LIST)
        if(!response.IsError) {
          this.feldList = response.Data
          this.feldList.unshift({
            ID: 0,
            Bezeichnung: ''
          })
        }
      } catch {
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  async mounted (): Promise<void> {
    this.fetchProductGroupList()
    this.fetchFeldList()
  }
})
